import { createReducer, on } from '@ngrx/store';

import { Country } from '@mp/organization-master-data/countries/domain';

import { CountriesActions } from './countries.actions';

export const countriesFeatureKey = 'mpomd-core-countries';

export interface CountriesState {
  countries: Country[];
  countriesLoaded: boolean;
}

export const initialState: CountriesState = {
  countries: [],
  countriesLoaded: true,
};

export const countriesReducer = createReducer(
  initialState,
  on(
    CountriesActions.fetchCountries,
    (state: CountriesState): CountriesState => ({
      ...state,
      countries: [],
      countriesLoaded: false,
    }),
  ),
  on(
    CountriesActions.fetchCountriesSuccess,
    (state: CountriesState, { countries }): CountriesState => ({
      ...state,
      countries,
      countriesLoaded: true,
    }),
  ),
  on(
    CountriesActions.fetchCountriesError,
    (state: CountriesState): CountriesState => ({
      ...state,
      countries: [],
      countriesLoaded: true,
    }),
  ),
);
